import { render, staticRenderFns } from "./SysSetting.vue?vue&type=template&id=1bb1284c"
import script from "./SysSetting.vue?vue&type=script&lang=js"
export * from "./SysSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports